import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useSearchAcademic = (searchTerm: string, year: number) => {
  return trpc.getFilteredAcademicList.useQuery(
    { searchTerm, year },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!searchTerm,
    },
  );
};
